import React from "react";
import Pagetitle from "../elements/Pagetitle";
import Timeline from "../elements/Timeline";

const experienceData1 = [
    {
        title: "Product Architect / Senior Full Stack Engineer, Querify",
        years: "Personally Developed, April 2026 - Present",
        content1:
            "Designed and built Querify, a multi-tenant Question-to-Knowledge SaaS platform that converts repeated customer, community, and team questions into reusable governed Q&A knowledge assets.",
        content2:
            "Architected modular product boundaries for Tenant, QnA, Direct, Broadcast, and Trust so identity, knowledge, private support, public/community workflows, and audit decisions remain independently owned.",
        content3:
            "Implemented React tenant Portal workflows with Auth0 authentication, workspace switching, QnA management, billing/profile/settings flows, localization, responsive navigation, and SignalR notification support.",
        content4:
            "Built .NET API and worker surfaces for tenant operations, authenticated QnA management, public client-key QnA access, source upload verification, billing webhook processing, and email outbox workflows.",
        content5:
            "Designed tenant-aware PostgreSQL persistence with EF Core, module-specific DbContexts, tenant connection routing, soft delete, audit behavior, migrations, seed tooling, integration tests, and architecture tests.",
        content6:
            "Integrated production-style infrastructure including RabbitMQ, MassTransit, Hangfire, Redis, S3-compatible object storage, Docker Compose, OpenTelemetry, Sentry, Swagger/OpenAPI, and observability tooling.",
        content7:
            "Resources Used: .NET 10, ASP.NET Core, EF Core, MediatR, PostgreSQL, React 19, TypeScript, Vite, Tailwind CSS, Auth0, RabbitMQ, MassTransit, Hangfire, SignalR, Redis, Docker, OpenTelemetry, Sentry, Swagger/OpenAPI, MCP.",
        content8: (
            <>
                Sample link:{" "}
                <a
                    className="colorpink"
                    href="https://dev.portal.querify.net/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://dev.portal.querify.net/
                </a>
            </>
        ),
    },
    {
        title: "Senior Full Stack Engineer, Caracal Technologies / VenTek International",
        years: "Feb 2024 - may 2026",
        content1:
            "Implemented a multi-tenant SSO supporting Google and Azure AD authentication, loading per-tenant configuration at runtime, mapping claims to users, provisioning accounts, supporting single logout, and integrating with existing MFA and trusted-device flows. Designed to work across multiple Oracle databases for tenant isolation and scalability.",
        content2:
            "Developed and maintained venVUE, an enterprise parking management and revenue control platform used by transit agencies, parking authorities, and municipalities across North America, processing millions of transactions annually.",
        content3:
            "Designed and implemented a Multi-Factor Authentication (MFA) solution with email/SMS delivery, trusted devices via browser fingerprinting, configurable session expiration, and account lockout protection.",
        content4:
            "Integrated AWS S3 and CloudFront for centralized configuration management and CDN-based distribution of operational files across geographically distributed parking infrastructure.",
        content5:
            "Architected and implemented a layered solution spanning Application, Domain, Infrastructure, and Web API layers, ensuring SOLID compliance and a clear separation of concerns.",
        content6:
            "Collaborated closely with Product and QA teams using Agile (SCRUM/Kanban), managing work through Jira and Bitbucket with structured code reviews.",
        content7:
            "Deployed and maintained applications on IIS / Windows Server, including custom HTTP modules, scheduled background jobs for report maintenance, and performance-optimized session handling.",
        content8:
            "Resources Used: .C#, .NET Core 10, .NET Framework 4.8, ASP.NET WebForms, Oracle, Dapper, Crystal Reports, Telerik UI, AWS S3, CloudFront, OWIN, REST APIs, HTML5, CSS3, JavaScript, Git, Jira, Agile (SCRUM/Kanban).",
    },
    {
        title: "Senior Full Stack Engineer, Telus Agriculture",
        years: "Feb 2024 - Out 2025",
        content1:
            "Developed a modern Animal Management platform, focused on enabling reliable synchronization between web, desktop, and mobile applications in both online and offline scenarios.",
        content2:
            "Migrated critical modules (ReHandling, Movement, Rail, Pens, and Animal records) from Entity Framework Core (SQL Server) to Couchbase Lite for offline-first desktop usage, ensuring data integrity and real-time replication, and vice versa back to the cloud to keep all contexts consistent.",
        content3:
            "Developed scalable microservices architecture with .NET Core and C#, integrating authentication, authorization, and dynamic queries while optimizing performance for high-volume datasets in the agriculture sector.",
        content4:
            "Improved data migration strategies to support multi-environment synchronization, ensuring smooth interoperability across cloud, on-premises, and edge devices.",
        content5:
            "Enhanced DevOps practices with Docker, GitHub Actions, and CI/CD pipelines, ensuring consistent delivery across environments.",
        content6:
            "Collaborated with QA and product teams to break down large PRs into incremental deliverables, accelerating feedback loops and improving agility.",
        content7:
            "Resources Used: .NET Core, C#, Couchbase Lite, SQL Server, SQLite, Angular, TypeScript, AutoMapper, Docker, GitHub Actions, Jira, Agile (Scrum/Kanban).",
    },
  {
    title: "Senior Full Stack Engineer, at Nutrien Agriculture",
    years: "Jan 2023 - Jan 2024",
    content1:
      "Developed advanced web systems for the agriculture sector, showcasing a blend of technical expertise and industry-specific knowledge.",
    content2:
      "Engineered the 'Material Balance' backend system in C# and .NET to process and calculate data for global agricultural sites. The system integrates background processes and utilizes LUA scripting for formula calculations, handling complex relationships across various types of crops.",
    content3:
      "Created a dynamic form system backend, enabling the creation of customizable form templates, field types, and validations. This system supports dynamic integrations with other microservices, providing logical dependencies for forms and fields. ",
    content4:
      "Developed a comprehensive backend system for user registration, authentication, and permission management, tailored to the specific business needs and permissions of each microservice and site. ",
    content5:
      "Implemented a front-end solution using React, Material Design UI, and React Query to provide a user-friendly interface. This included features such as user registration, process management, user profiles, authentication screens, and formula execution. ",
    content6:
      "Utilized the AWS Cloud Development Kit (CDK) with TypeScript for setting up development, UAT, and production environments on AWS. Employed continuous integration and deployment (CI/CD) practices using CircleCI.",
    content7:
      "Resources Used: AWS Lambda, AWS Events, AWS S3, AWS Cognito, C#, .NET, JavaScript, TypeScript, Node.js, SQL Server, MongoDB, DynamoDB, CDK, GitHub, Circle CI.",
  },
];

const experienceData2 = [
    {
        title: "Senior Software Engineer, at Gluwa Technologies Inc.",
        years: "Feb 2021 - Jan 2023",
        content1:
            "Led API development for blockchain operations, smart contract behavior on BTC/ETH networks, including cryptocurrency support, and mobile app integration.",
        content2:
            "Utilized C#, .NET Core, SQL Server, and Azure to develop and maintain microservices in a web environment.",
        content3:
            "Applied SCRUM and Kanban methodologies, integrating unit tests, azure functions, blob storage, and push notifications for enhanced application performance.",
    },
    {
        title: "Full Stack Developer & Technical Leader, at Integritas Resources Inc.",
        years: "May 2018 – Feb 2021",
        content1: {
            title: "Project: Multi-Tenant Asset Management and Help-Desk System",
            description1: "Developed back-end architecture and front-end components for a highly scalable, microservice-based system. Focused on security and efficient data management for multi-tenant configurations. Resources Used: .NET, C#, JavaScript, TypeScript, React, AWS, SQL Server, ElasticSearch, RabbitMQ, Docker, Kubernetes."
        },
        content2: {
            title: "Project: Drilling Management System for Oil and Gas Company",
            description1: "Spearheaded the front-end development of a comprehensive drilling management system, catering to the oil and gas sector, with and without the integration of artificial intelligence. Implemented advanced data visualization techniques to render complex drilling data into user-friendly graphics, ensuring high usability standards. Developed a real-time data presentation feature to facilitate prompt decision-making in critical drilling operations.",
            description2: "Optimized performance and responsiveness for both web and mobile platforms, ensuring seamless user experience across devices. Employed Agile methodologies, including Scrum and Kanban, for effective project management and team collaboration. Resources Used: HTML5, CSS3, JavaScript, React (for web), React Native (for mobile), Agile methodologies (Scrum, Kanban). "
        },
        content3: {
            title: "Project: Content Management System for Oil and Gas Company",
            description1: "Led the technical development and provided strategic direction for a comprehensive management system in the oil and gas sector. Engineered a robust content management system, seamlessly integrated with Amazon Web Services for optimized performance and scalability. Oversaw both front-end and back-end development, ensuring a cohesive and user-friendly interface coupled with a reliable back-end infrastructure. Resources Used: C#, SQL Server, .NET Core, TypeScript, WebAPI, JavaScript, Angular, ASP.NET Boilerplate, AWS services, Git, Jira. "
        },
    },
  {
    title: "Senior Full Stack Developer & Technical Leader, at EZSOFT",
    years: "Feb 2016 – Feb 2018",
    content1:
      "Spearheaded the development of a cutting-edge platform for private health insurance sales, showcasing innovation and specialized skills in a complex industry. ",
    content2:
      "Developed and maintained versatile systems for real estate, insurance sales, and multi-level marketing, leveraging C#, TypeScript, and JavaScript. ",
    content3:
      "Applied advanced proficiency in the ASP.NET Boilerplate framework, adopting Domain-Driven Design (DDD) and TDD techniques to ensure code quality and robust application architecture. ",
    content4:
      "Led development and support teams, fostering a collaborative and productive work environment. ",
    content5:
      "Implemented Agile methodologies, including SCRUM and KANBAN, to effectively manage development processes. This included defining project deliverables, refining and prioritizing development tasks, and overseeing project timelines. ",
    content6:
      "Established and managed comprehensive knowledge bases, enhancing team expertise and supporting continuous development. ",
  },
  {
    title: "Systems Analyst, at CMCorp Soluções em Informática",
    years: "Nov 2013 – Feb 2016",
    content1:
      "Contributed to the development of a cloud-based ERP system using C#, DDD techniques, JavaScript, .NET, and AngularJs frameworks and Integrated solutions with third-party. ",
    content2:
      "Designed and developed responsive websites using HTML5, CSS3, and JavaScript, working closely with the marketing team from wireframes and Photoshop layouts. ",
    content3:
      "Developed mobile applications using HTML5 and the Ionic framework for Android and iOS platforms. ",
  },
  {
    title: "Social Experience - Communication Coordinator, at ARJ Pathfinders",
    years: "Jan 2011 – Feb 2014",
    content1:
      "Worked as communication coordinator of the metropolitan region of Rio de Janeiro to develop talents, skills, perceptions and the taste for nature with boys and girls between the ages of 10 and 15, of different social classes, color, ethnicity and religion. ",
  },
  {
    title: "Systems Analyst, at INFBRAS Informática ",
    years: "Jan 2009 – Nov 2013",
    content1:
      "Developed and managed institutional websites, content management systems, and intranets using PHP, HTML, CSS, JavaScript, jQuery, MySQL, PostgreSQL. ",
    content2:
      "Worked with CMS platforms like Joomla and WordPress on both Windows and Linux servers, including Apache, IIS, and Nginx. ",
  },
  {
    title: "IT Analyst. at Ciferal Ind. de Ônibus Ltda.",
    years: "May 2005 – Aug 2008",
    content1:
      "Deployed and managed Windows Server and Linux domain servers and clients. ",
    content2:
      "Developed Visual Basic scripts for Windows resource management and created tools using PHP, XHTML, CSS, JavaScript, MySQL, and SAMBA. ",
    content3:
      "Oversaw the procurement of computer equipment and the design and deployment of network infrastructure. ",
  },
];

function Experiences() {
  return (
    <section id="experience">
      <div className="container">
        <Pagetitle title="Experience" />
        <div className="row">
          <div className="col-md-6">
            <div className="timeline exp bg-white rounded shadow-dark padding-30 overflow-hidden">
              {experienceData1.map((education, key) => (
                <Timeline key={key} education={education} />
              ))}
              <span className="line"></span>
            </div>
          </div>

          <div className="col-md-6">
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
            <div className="timeline exp bg-white rounded shadow-dark padding-30 overflow-hidden">
              {experienceData2.map((experience, key) => (
                <Timeline key={key} education={experience} />
              ))}
              <span className="line"></span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 text-center">
        <p className="mb-0">
          Looking for more information?{" "}
          <a
            className="colorpink pointer"
            href="https://1drv.ms/b/s!AhG6K52WP6wkiON-HtENnMJNHqPCww?e=WgroBh"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here
          </a>{" "}
          to download my resume! 👋
        </p>
      </div>
    </section>
  );
}

export default Experiences;
